import { render, staticRenderFns } from "./FormMedical.vue?vue&type=template&id=5c92f58a&scoped=true"
import script from "./FormMedical.vue?vue&type=script&lang=js"
export * from "./FormMedical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c92f58a",
  null
  
)

export default component.exports